import { render, staticRenderFns } from "./matrixPage.vue?vue&type=template&id=70463130&"
import script from "./matrixPage.vue?vue&type=script&lang=js&"
export * from "./matrixPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports